<template>
    <div v-if="isShow" :style="domStyle">
        <Carousel v-if="isrefresh" v-model="value1" :loop="loop" :autoplay="autoplay" :arrow="arrow" :dots="dots" @on-change="getIndex":style="imgStyle" >
            <CarouselItem v-for="val,key in imgList" :key="key":style="imgStyle" >
                <img :src="val.img" :width="domStyle.width" :height="domStyle.height" @click="changeIndex">
            </CarouselItem>
        </Carousel>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        this.defaultTailoring = this.parentObject.defaultTailoring;
        this.windowSize = this.parentObject.windowSize;
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.imgStyle = {
            width : this.width + "px",
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        if(this.OnClick && this.OnClick != "%OnClick%"){
            this.OnClick = AsyncFunction("index",this.OnClick);
        }
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            value1 : 0 ,
            loop : false,          //自动循环
            autoplay:true,        //自动轮播
            dots : "none",      //指示器位置
            arrow : "always",      //箭头显示
            isrefresh : true,     
            index: 0,             //初始下标
            // 版本号
            version: "10.0.3.1" 
        }
    },
    methods : {
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + scaleObj.titleHeight + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.imgStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            // this.imgStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.isrefresh = false;
            // 利用v-if 强制重新渲染组件
            this.$nextTick(() => {
                this.isrefresh = true;
            })
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
            if(this.isEnable){
                this.arrow = "never";
                this.autoplay = false;
            }else{
                this.arrow = "always";
                this.autoplay = true;
            }
        },
        /*
            参数：oldValue 旧下标，value当前下标
            作用：获取当前下标
        */
        getIndex(oldValue,value){
            this.index = value;
        },
        /*
            参数：index 当前轮播图下标
            作用：触发用户所设置的控件事件
        */
        changeIndex(){
            if(typeof this.OnClick == "function"){
               this.fvSystemApi.executionScript(this.OnClick,this.index);
            }
        },
    }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/primitives/fvCarousel/fvCarousel.vue